module.exports = __webpack_public_path__ + "img/adams first graduate letter.cc4c4f42.jpg";